<div class="segment-tabs">
  @for (tab of tabs; track tab.value) {
  <ds-button [buttonInput]="getButtonInput(tab)" (btnClick)="onSelect(tab)"></ds-button>
  }
</div>
